import React, { useState, useEffect } from 'react';
import Plotly from 'react-plotly.js';
import { getChartColors } from '../../utils/chartColors';

const PieChart = ({ data }) => {
  const [themeKey, setThemeKey] = useState(0);

  // Listen for theme changes
  useEffect(() => {
    const checkThemeChange = () => {
      setThemeKey(prev => prev + 1);
    };

    // Listen for DOM mutations (theme class changes)
    const observer = new MutationObserver(checkThemeChange);
    const landingPage = document.querySelector('.landing-page');
    if (landingPage) {
      observer.observe(landingPage, { attributes: true, attributeFilter: ['class'] });
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  if (!data) {
    return <div>Loading...</div>;
  }

  // Prepare data for Plotly
  const labels = ['BTC', 'ETH', 'SOL'];
  const values = [
    data.bitcoin?.usdValue || 0,
    data.ethereum?.usdValue || 0,
    data.solana?.usdValue || 0
  ];
  
  // Asset colors - matching card colors with transparency
  const colors = ['rgba(251, 191, 36, 0.8)', 'rgba(59, 130, 246, 0.8)', 'rgba(139, 92, 246, 0.8)']; // Gold (BTC), Blue (ETH), Purple (SOL)

  // Check if we're in dark mode
  const isDarkMode = !document.querySelector('.landing-page')?.classList.contains('light-mode');
  
  const plotData = [{
    type: 'pie',
    labels: labels,
    values: values,
    hole: 0.6, // Larger hole for thinner slices
    textinfo: 'none',
    marker: {
      colors: colors,
      line: {
        color: isDarkMode ? '#888888' : '#000000',
        width: 0.5
      }
    },
    hovertemplate: '<b>%{label}</b><br>Value: $%{value:,.0f}<br>Percentage: %{percent}<extra></extra>'
  }];

  const layout = {
    showlegend: false,
    paper_bgcolor: 'rgba(0,0,0,0)',
    plot_bgcolor: 'rgba(0,0,0,0)',
    font: {
      color: getChartColors().text,
      family: "'TWK Everett', sans-serif"
    },
    margin: {
      l: 20,
      r: 20,
      t: 20,
      b: 20
    },
    autosize: true
  };

  const config = {
    displayModeBar: false,
    responsive: true
  };

  return (
    <div className="pie-chart-container">
      <Plotly
        key={themeKey}
        data={plotData}
        layout={layout}
        config={config}
        style={{ width: '100%', height: '100%' }}
      />
    </div>
  );
};

export default PieChart;
